import React, { useState, useEffect } from "react";
import Table from "react-bootstrap/Table";
import { styles } from "../../styles/styles.js";
import { StarRating } from "../../components/starrating.js";
import { useAppState } from "../../AppStateContext.js";
import * as motion from "motion/react-client";
import ReactMarkdown from "react-markdown";
import HorizontalBarChart from "./barchart.js";
import { LastTen } from "./lastten.js";
import { fmt, sum, diff, rate, rateValue, record, stars } from "../../utils/format.js";

function shouldShowLastSeason(fixture) {
  if (fixture.league === "NFL" || fixture.league === "NHL") {
    return true;
  }
  // Unknown season progress is not early-season. Showing a "Last Season" row we
  // cannot justify is worse than omitting it, and the old unguarded deref threw.
  return fixture.ratings?.progress != null && fixture.ratings.progress < 0.15;
}


function Spreads({ fixture }) {
  const [displayMode, setDisplayMode] = useState(2);
  const { isTutorialMode } = useAppState();

  // const [isAutoCycling, setIsAutoCycling] = useState(true);

  // useEffect(() => {
  //   let interval;
  //   if (isAutoCycling) {
  //     interval = setInterval(() => {
  //       setDisplayMode((prevMode) => (prevMode + 1) % 3);
  //     }, 10000);
  //   }
  //   return () => clearInterval(interval);
  // }, [isAutoCycling]);

  const toggleDisplayMode = () => {
    // setIsAutoCycling(false);
    setDisplayMode((prevMode) => (prevMode + 1) % 3);
  };
  const AnimatedCell = ({ children }) => (
    <motion.div
      key={displayMode}
      initial={{ opacity: 0, x: -100 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{
        duration: 0.5,
        scale: { type: "spring", damping: 10, stiffness: 100, bounce: 0.5 },
      }}>
      {children}
    </motion.div>
  );

  if (fixture.recent) {

    return (
      <>
        {displayMode !== 2 && (
        <Table bordered className="main">
          <tbody>
          <tr style={styles.Cells}>
            <td className="Cells" style={styles.column_1} onClick={toggleDisplayMode}>
              Spreads
            </td>
            <td className="Cells" style={styles.Cells}></td>
            <td className="Cells" style={styles.Cells}></td>
          </tr>
          <tr>
            <td className="Cells" style={styles.column_1} onClick={toggleDisplayMode}></td>
            <td className="Cells" style={styles.column_1}>{fixture.home_team}</td>
            <td className="Cells" style={styles.column_1}>{fixture.away_team}</td>

          </tr>
          <tr style={styles.Cells}>
            <td className="Cells" style={styles.column_1} onClick={toggleDisplayMode}>
              Last 3
            </td>
            <td className="Cells" style={styles.Cells}>
              <AnimatedCell>
              {displayMode === 0
                ? record(fixture.recent.home_spread_3, fixture.recent.home_spread_sample_3, 3)
                : displayMode === 1
                ? rate(fixture.recent.home_spread_3, fixture.recent.home_spread_sample_3, 3)
                : <StarRating rating={stars(
                    rateValue(fixture.recent.home_spread_3, fixture.recent.home_spread_sample_3, 3),
                    rateValue(fixture.recent.away_spread_3, fixture.recent.away_spread_sample_3, 3)
                  )} />
              }
              </AnimatedCell>
            </td>
            <td className="Cells" style={styles.Cells}>
              <AnimatedCell>
              {displayMode === 0
                ? record(fixture.recent.away_spread_3, fixture.recent.away_spread_sample_3, 3)
                : displayMode === 1
                ? rate(fixture.recent.away_spread_3, fixture.recent.away_spread_sample_3, 3)
                : <StarRating rating={stars(
                    rateValue(fixture.recent.away_spread_3, fixture.recent.away_spread_sample_3, 3),
                    rateValue(fixture.recent.home_spread_3, fixture.recent.home_spread_sample_3, 3)
                  )} />
              }
              </AnimatedCell>
            </td>
          </tr>

          <tr style={styles.Cells}>
            <td className="Cells" style={styles.column_1} onClick={toggleDisplayMode}>
              Last 5
            </td>
            <td className="Cells" style={styles.Cells}>
              <AnimatedCell>
              {displayMode === 0
                ? record(fixture.recent.home_spread_5, fixture.recent.home_spread_sample_5, 5)
                : displayMode === 1
                ? rate(fixture.recent.home_spread_5, fixture.recent.home_spread_sample_5, 5)
                : <StarRating rating={stars(
                    rateValue(fixture.recent.home_spread_5, fixture.recent.home_spread_sample_5, 5),
                    rateValue(fixture.recent.away_spread_5, fixture.recent.away_spread_sample_5, 5)
                  )} />
              }
              </AnimatedCell>
            </td>
            <td className="Cells" style={styles.Cells}>
              <AnimatedCell>
              {displayMode === 0
                ? record(fixture.recent.away_spread_5, fixture.recent.away_spread_sample_5, 5)
                : displayMode === 1
                ? rate(fixture.recent.away_spread_5, fixture.recent.away_spread_sample_5, 5)
                : <StarRating rating={stars(
                    rateValue(fixture.recent.away_spread_5, fixture.recent.away_spread_sample_5, 5),
                    rateValue(fixture.recent.home_spread_5, fixture.recent.home_spread_sample_5, 5)
                  )} />
              }
              </AnimatedCell>
            </td>
          </tr>

          <tr style={styles.Cells}>
            <td className="Cells" style={styles.column_1} onClick={toggleDisplayMode}>
              Last 10
            </td>
            <td className="Cells" style={styles.Cells}>
              <AnimatedCell>
              {displayMode === 0
                ? record(fixture.recent.home_spread_10, fixture.recent.home_spread_sample_10, 10)
                : displayMode === 1
                ? rate(fixture.recent.home_spread_10, fixture.recent.home_spread_sample_10, 10)
                : <StarRating rating={stars(
                    rateValue(fixture.recent.home_spread_10, fixture.recent.home_spread_sample_10, 10),
                    rateValue(fixture.recent.away_spread_10, fixture.recent.away_spread_sample_10, 10)
                  )} />
              }
              </AnimatedCell>
            </td>
            <td className="Cells" style={styles.Cells}>
              <AnimatedCell>
              {displayMode === 0
                ? record(fixture.recent.away_spread_10, fixture.recent.away_spread_sample_10, 10)
                : displayMode === 1
                ? rate(fixture.recent.away_spread_10, fixture.recent.away_spread_sample_10, 10)
                : <StarRating rating={stars(
                    rateValue(fixture.recent.away_spread_10, fixture.recent.away_spread_sample_10, 10),
                    rateValue(fixture.recent.home_spread_10, fixture.recent.home_spread_sample_10, 10)
                  )} />
              }
              </AnimatedCell>
            </td>
          </tr>
          <tr style={styles.Cells}>
            <td className="Cells" style={styles.column_1} onClick={toggleDisplayMode}>
              Season
            </td>
            <td className="Cells" style={styles.Cells}>
              <AnimatedCell>
              {displayMode === 0
                ? record(fixture.stats?.home_spread, fixture.stats?.home_spread_sample, fixture.stats?.count_home)
                : displayMode === 1
                ? rate(fixture.stats?.home_spread, fixture.stats?.home_spread_sample, fixture.stats?.count_home)
                : <StarRating rating={stars(
                    rateValue(fixture.stats?.home_spread, fixture.stats?.home_spread_sample, fixture.stats?.count_home),
                    rateValue(fixture.stats?.away_spread, fixture.stats?.away_spread_sample, fixture.stats?.count_away)
                  )} />
              }
              </AnimatedCell>
            </td>
            <td className="Cells" style={styles.Cells}>
              <AnimatedCell>
              {displayMode === 0
                ? record(fixture.stats?.away_spread, fixture.stats?.away_spread_sample, fixture.stats?.count_away)
                : displayMode === 1
                ? rate(fixture.stats?.away_spread, fixture.stats?.away_spread_sample, fixture.stats?.count_away)
                : <StarRating rating={stars(
                    rateValue(fixture.stats?.away_spread, fixture.stats?.away_spread_sample, fixture.stats?.count_away),
                    rateValue(fixture.stats?.home_spread, fixture.stats?.home_spread_sample, fixture.stats?.count_home)
                  )} />
              }
              </AnimatedCell>
            </td>
          </tr>
          {shouldShowLastSeason(fixture) && (
            <tr style={styles.Cells}>
              <td className="Cells" style={styles.column_1} onClick={toggleDisplayMode}>
                Last Season
              </td>
              <td className="Cells" style={styles.Cells}>
                <AnimatedCell>
                {displayMode === 0
                  ? record(fixture.stats?.home_spread_last, fixture.stats?.home_spread_sample_last, fixture.stats?.count_home_last)
                  : displayMode === 1
                  ? rate(fixture.stats?.home_spread_last, fixture.stats?.home_spread_sample_last, fixture.stats?.count_home_last)
                  : <StarRating rating={stars(
                      rateValue(fixture.stats?.home_spread_last, fixture.stats?.home_spread_sample_last, fixture.stats?.count_home_last),
                      rateValue(fixture.stats?.away_spread_last, fixture.stats?.away_spread_sample_last, fixture.stats?.count_away_last)
                    )} />
                }
                </AnimatedCell>
              </td>
              <td className="Cells" style={styles.Cells}>
                <AnimatedCell>
                {displayMode === 0
                  ? record(fixture.stats?.away_spread_last, fixture.stats?.away_spread_sample_last, fixture.stats?.count_away_last)
                  : displayMode === 1
                  ? rate(fixture.stats?.away_spread_last, fixture.stats?.away_spread_sample_last, fixture.stats?.count_away_last)
                  : <StarRating rating={stars(
                      rateValue(fixture.stats?.away_spread_last, fixture.stats?.away_spread_sample_last, fixture.stats?.count_away_last),
                      rateValue(fixture.stats?.home_spread_last, fixture.stats?.home_spread_sample_last, fixture.stats?.count_home_last)
                    )} />
                }
                </AnimatedCell>
              </td>
            </tr>
          )}
          <tr style={{...styles.Cells, borderTop: '0', borderBottom: '0'}} >
            <td className="Cells" style={{...styles.Cells, borderTop: '0', borderBottom: '0'}} colSpan="3">&nbsp;</td>
          </tr>
          <tr style={{...styles.Cells, borderTop: '0', borderBottom: '0'}} >
            <td className="Cells" style={{...styles.Cells, borderTop: '0', borderBottom: '0'}} colSpan="3">&nbsp;</td>
          </tr>
          <tr style={styles.Cells}>
            <td className="Cells" style={styles.column_1} onClick={toggleDisplayMode}>
              Home
            </td>
            <td className="Cells" style={styles.Cells}>
              <AnimatedCell>
              {displayMode === 0
                ? `${fmt(fixture.stats?.home_home_spreads_covered, 0)} - ${fmt(fixture.stats?.home_home_spreads_not_covered, 0)}`
                : displayMode === 1
                ? rate(fixture.stats?.home_home_spreads_covered, sum(fixture.stats?.home_home_spreads_covered, fixture.stats?.home_home_spreads_not_covered), fixture.stats?.home_home_games)
                : <StarRating rating={stars(
                    rateValue(fixture.stats?.home_home_spreads_covered, sum(fixture.stats?.home_home_spreads_covered, fixture.stats?.home_home_spreads_not_covered), fixture.stats?.home_home_games),
                    rateValue(fixture.stats?.away_away_spreads_covered, sum(fixture.stats?.away_away_spreads_covered, fixture.stats?.away_away_spreads_not_covered), fixture.stats?.away_away_games)
                  )} />
              }
              </AnimatedCell>
            </td>
            <td className="Cells" style={styles.Cells}></td>
          </tr>
          <tr style={styles.Cells}>
            <td className="Cells" style={styles.column_1} onClick={toggleDisplayMode}>
              Away
            </td>
            <td className="Cells" style={styles.Cells}></td>
            <td className="Cells" style={styles.Cells}>
              <AnimatedCell>
              {displayMode === 0
                ? `${fmt(fixture.stats?.away_away_spreads_covered, 0)} - ${fmt(fixture.stats?.away_away_spreads_not_covered, 0)}`
                : displayMode === 1
                ? rate(fixture.stats?.away_away_spreads_covered, sum(fixture.stats?.away_away_spreads_covered, fixture.stats?.away_away_spreads_not_covered), fixture.stats?.away_away_games)
                : <StarRating rating={stars(
                    rateValue(fixture.stats?.away_away_spreads_covered, sum(fixture.stats?.away_away_spreads_covered, fixture.stats?.away_away_spreads_not_covered), fixture.stats?.away_away_games),
                    rateValue(fixture.stats?.home_home_spreads_covered, sum(fixture.stats?.home_home_spreads_covered, fixture.stats?.home_home_spreads_not_covered), fixture.stats?.home_home_games)
                  )} />
              }
              </AnimatedCell>
            </td>
          </tr>
          {shouldShowLastSeason(fixture) && (
            <>
              <tr style={styles.Cells}>
                <td className="Cells" style={styles.column_1} onClick={toggleDisplayMode}>
                  Home Last Season
                </td>
                <td className="Cells" style={styles.Cells}>
                  <AnimatedCell>
                  {displayMode === 0
                    ? `${fmt(fixture.stats?.home_home_spreads_covered_last, 0)} - ${fmt(fixture.stats?.home_home_spreads_not_covered_last, 0)}`
                    : displayMode === 1
                    ? rate(fixture.stats?.home_home_spreads_covered_last, sum(fixture.stats?.home_home_spreads_covered_last, fixture.stats?.home_home_spreads_not_covered_last), fixture.stats?.home_home_games_last)
                    : <StarRating rating={stars(
                        rateValue(fixture.stats?.home_home_spreads_covered_last, sum(fixture.stats?.home_home_spreads_covered_last, fixture.stats?.home_home_spreads_not_covered_last), fixture.stats?.home_home_games_last),
                        rateValue(fixture.stats?.away_home_spreads_covered_last, sum(fixture.stats?.away_home_spreads_covered_last, fixture.stats?.away_home_spreads_not_covered_last), fixture.stats?.away_home_games_last)
                      )} />
                  }
                  </AnimatedCell>
                </td>
                <td className="Cells" style={styles.Cells}>
                  <AnimatedCell>
                  {displayMode === 0
                    ? `${fmt(fixture.stats?.away_home_spreads_covered_last, 0)} - ${fmt(fixture.stats?.away_home_spreads_not_covered_last, 0)}`
                    : displayMode === 1
                    ? rate(fixture.stats?.away_home_spreads_covered_last, sum(fixture.stats?.away_home_spreads_covered_last, fixture.stats?.away_home_spreads_not_covered_last), fixture.stats?.away_home_games_last)
                    : <StarRating rating={stars(
                        rateValue(fixture.stats?.away_home_spreads_covered_last, sum(fixture.stats?.away_home_spreads_covered_last, fixture.stats?.away_home_spreads_not_covered_last), fixture.stats?.away_home_games_last),
                        rateValue(fixture.stats?.home_home_spreads_covered_last, sum(fixture.stats?.home_home_spreads_covered_last, fixture.stats?.home_home_spreads_not_covered_last), fixture.stats?.home_home_games_last)
                      )} />
                  }
                  </AnimatedCell>
                </td>
              </tr>
              <tr style={styles.Cells}>
                <td className="Cells" style={styles.column_1} onClick={toggleDisplayMode}>
                  Away Last Season
                </td>
                <td className="Cells" style={styles.Cells}>
                  <AnimatedCell>
                  {displayMode === 0
                    ? `${fmt(fixture.stats?.home_away_spreads_covered_last, 0)} - ${fmt(fixture.stats?.home_away_spreads_not_covered_last, 0)}`
                    : displayMode === 1
                    ? rate(fixture.stats?.home_away_spreads_covered_last, sum(fixture.stats?.home_away_spreads_covered_last, fixture.stats?.home_away_spreads_not_covered_last), fixture.stats?.home_away_games_last)
                    : <StarRating rating={stars(
                        rateValue(fixture.stats?.home_away_spreads_covered_last, sum(fixture.stats?.home_away_spreads_covered_last, fixture.stats?.home_away_spreads_not_covered_last), fixture.stats?.home_away_games_last),
                        rateValue(fixture.stats?.away_away_spreads_covered_last, sum(fixture.stats?.away_away_spreads_covered_last, fixture.stats?.away_away_spreads_not_covered_last), fixture.stats?.away_away_games_last)
                      )} />
                  }
                  </AnimatedCell>
                </td>
                <td className="Cells" style={styles.Cells}>
                  <AnimatedCell>
                  {displayMode === 0
                    ? `${fmt(fixture.stats?.away_away_spreads_covered_last, 0)} - ${fmt(fixture.stats?.away_away_spreads_not_covered_last, 0)}`
                    : displayMode === 1
                    ? rate(fixture.stats?.away_away_spreads_covered_last, sum(fixture.stats?.away_away_spreads_covered_last, fixture.stats?.away_away_spreads_not_covered_last), fixture.stats?.away_away_games_last)
                    : <StarRating rating={stars(
                        rateValue(fixture.stats?.away_away_spreads_covered_last, sum(fixture.stats?.away_away_spreads_covered_last, fixture.stats?.away_away_spreads_not_covered_last), fixture.stats?.away_away_games_last),
                        rateValue(fixture.stats?.home_away_spreads_covered_last, sum(fixture.stats?.home_away_spreads_covered_last, fixture.stats?.home_away_spreads_not_covered_last), fixture.stats?.home_away_games_last)
                      )} />
                  }
                  </AnimatedCell>
                </td>
              </tr>
            </>
          )}
        </tbody>
        </Table>
        )}
        {displayMode === 2 && (
      <div style={{
        width: "100%",
        marginTop: "0px",
        alignSelf: "flex-start"
      }}>
        <Table bordered className="main" onClick={toggleDisplayMode}>
          <tbody>
            <tr style={styles.Cells}>
              <td className="Cells" style={styles.column_1}>
                Spreads
              </td>
              <td className="Cells" style={styles.Cells}></td>
              <td className="Cells" style={styles.Cells}></td>
            </tr>
            <tr>
          <td className="Cells" style={{...styles.column_1, width: "5%"}}>
          </td>
          <td className="Cells" style={{...styles.column_1, width: "25%"}}>
            {fixture.home_team}
          </td>
          <td className="Cells" style={{...styles.column_1, width: "25%"}}>
            {fixture.away_team}
          </td>
            </tr>
          </tbody>
        </Table>
        {/* rawData feeds Math.max and a Recharts domain — every entry stays
            number | null. An em-dash here would produce NaN and no axis. */}
        <HorizontalBarChart
          shortNames={["3G", "5G", "10G", "SN", "HA"]}
          rawData={[
            diff(rateValue(fixture.recent.away_spread_3, fixture.recent.away_spread_sample_3, 3), rateValue(fixture.recent.home_spread_3, fixture.recent.home_spread_sample_3, 3)),
            diff(rateValue(fixture.recent.away_spread_5, fixture.recent.away_spread_sample_5, 5), rateValue(fixture.recent.home_spread_5, fixture.recent.home_spread_sample_5, 5)),
            diff(rateValue(fixture.recent.away_spread_10, fixture.recent.away_spread_sample_10, 10), rateValue(fixture.recent.home_spread_10, fixture.recent.home_spread_sample_10, 10)),
            diff(
              rateValue(fixture.stats?.away_spread, fixture.stats?.away_spread_sample, fixture.stats?.count_away),
              rateValue(fixture.stats?.home_spread, fixture.stats?.home_spread_sample, fixture.stats?.count_home)
            ),
            diff(
              rateValue(fixture.stats?.away_away_spreads_covered, sum(fixture.stats?.away_away_spreads_covered, fixture.stats?.away_away_spreads_not_covered), fixture.stats?.away_away_games),
              rateValue(fixture.stats?.home_home_spreads_covered, sum(fixture.stats?.home_home_spreads_covered, fixture.stats?.home_home_spreads_not_covered), fixture.stats?.home_home_games)
            )
          ]}
          names={["Last 3", "Last 5", "Last 10", "Season", "Home and Away"]}
          onClick={toggleDisplayMode}

        />
      </div>
    )}

        <div style={{ height: '5vh' }}></div>
        <LastTen
          results={Array(10)
            .fill()
            .map((_, i) => fixture.recent[`home_${i + 1}_spread_covered`])
            .reverse()}
          title={fixture.home_team + ' spreads covered'}
        />
        <div style={{ height: '2vh' }}></div>
        <LastTen
          results={Array(10)
            .fill()
            .map((_, i) => fixture.recent[`away_${i + 1}_spread_covered`])
            .reverse()}
          title={fixture.away_team + ' spreads covered'}
        />
        <div style={{ height: '5vh' }}></div>

        <div style={{ marginTop: '20px' }}>
          {fixture.box_score && (
            <ul style={{
              listStyleType: 'none',
              padding: 0,
              margin: 0,
              fontSize: 'clamp(10px, calc(7px + (4) * ((100vw - 300px) / (1200 - 320))), 18px)'
            }}>
              <ReactMarkdown>{fixture.box_score['spreads_stats']}</ReactMarkdown>
            </ul>
          )}
        </div>

        {isTutorialMode && (
          <ul style={{ fontSize: 'clamp(12px, calc(12px + (4) * ((100vw - 300px) / (1200 - 320))), 18px)', marginBottom: '20px', textAlign: 'left', listStyleType: 'none', paddingLeft: '0' }}>
            <li>• Tap anywhere in the first column to toggle between modes</li>
            <ul style={{ paddingLeft: '20px', listStyleType: 'none' }}>
              <li>◦ Win-Loss mode - show the spread record</li>
              <li>◦ Percentage mode - show the spread cover percentage</li>
              <li>◦ Star mode - for quick evaluation of spread performance</li>
            </ul>
            <li>• Star ratings
              <ul style={{ paddingLeft: '20px', listStyleType: 'none' }}>
                <li>◦ ⭐ – Slight advantage in covering spreads</li>
                <li>◦ ⭐⭐ – Moderate advantage in covering spreads</li>
                <li>◦ ⭐⭐⭐ – Strong advantage in covering spreads</li>
              </ul>
            </li>
            <li>• How to interpret the data</li>
            <ul style={{ paddingLeft: '20px', listStyleType: 'none' }}>
              <li>◦ Compare recent spread coverage (last 3, 5, 10 games) to season-long performance</li>
              <li>◦ Pay attention to home/away spread coverage differences</li>
            </ul>
          </ul>
        )}
      </>
    );
  }
  return null;
}

export default Spreads;
